import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSRptOrdenesPendientes (ordenesProveedores) {
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Ordenes de Proveedores",
        Subject: "Ordenes",
        Author: "SGC",
        CreatedDate: new Date()
      };

      let data = [[
        'Nro Orden',
        'Fecha Orden',
        'Proveedor',
        'Presupuesto',
        'Moneda',
        'Importe',
        'Saldo',
        'Usuario'
      ]];

      if (ordenesProveedores.length != 0) {
        ordenesProveedores.forEach(ordenProveedor => {
          data.push([
            // this.$options.filters.fecha(compra.fechaRegistro),
            ordenProveedor.id,
            this.$options.filters.fecha(ordenProveedor.fechaComprobante),
            ordenProveedor.proveedor,
            ordenProveedor.presupuesto,
            ordenProveedor.moneda,
            ordenProveedor.importe,
            ordenProveedor.saldo,
            ordenProveedor.usuario
          ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "ordenes-proveedores");
      XLSX.writeFile(wb, "ordenes-proveedores.xlsx");

      return;
    },

  }
}
